export default "__VITE_ASSET__VCD3LPCe__"